import React from "react";
import PropTypes from "prop-types";

import ColorPicker from "../../../../shared/ColorPicker";

const ColorField = ({ label, value, onChange }) => (
  <div className="sf-color-control">
    <span className="sf-hint">{label}</span>
    <ColorPicker value={value || ""} onChange={onChange} inputPlaceholder="#000000" />
  </div>
);

ColorField.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default ColorField;
